var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('van-empty',{staticClass:"custom-image",attrs:{"image":require('@/assets/result-empty.png'),"description":"暂无记录"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }